
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/character",
      function () {
        return require("private-next-pages/character/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/character"])
      });
    }
  